import axios from 'axios';

const setupGlobalLoader = (setIsLoading) => {
    // Interceptor to handle the request state
    const requestInterceptor = axios.interceptors.request.use(config => {
        setIsLoading(true); // Set loading to true before making a request
        return config;
    });

    // Interceptor to handle the response state
    const responseInterceptor = axios.interceptors.response.use(
        response => {
            setIsLoading(false); // Set loading to false after a response is received
            return response;
        },
        error => {
            setIsLoading(false); // Set loading to false even if there is an error
            return Promise.reject(error);
        }
    );

    // Cleanup function to eject interceptors
    return () => {
        axios.interceptors.request.eject(requestInterceptor);
        axios.interceptors.response.eject(responseInterceptor);
    };
};

export default setupGlobalLoader;